import React from 'react';
import PropTypes from 'prop-types';
import BetSlipInput from 'Components/BetSlip/Input';
import { classnames } from 'Utils/classnames';
import Icon from 'Components/Icon';

const HorseRacingBetSlipInfoItem = ({
  id,
  label,
  value,
  type,
  inputMaxLength,
  onChange,
  onBlur,
  className,
  onFocus,
  onClick,
  couponAmount,
  style,
  onInfoClick,
  disabled
}, ref) => {
 
  const renderValue = () => {
    if (type === 'input') {
      return <BetSlipInput
        id={ id }
        maxLength={ inputMaxLength }
        value={ value }
        onFocus={ onFocus }
        onClick={ onClick }
        onChange={ onChange }
        onBlur={ onBlur }
        disabled={ disabled }
        ref={ ref }
      />;
    }

    if (type === 'clickable') {
      return <a title={ value } className={ classnames({
        'horse-racing-betslip__input': true,
        disabled: disabled
      }) } onClick={ onClick } id={ id }>
        <div className="horse-racing-betslip__input__value">{ value }</div>

        <Icon className="horse-racing-betslip__input__icon" iconName="svgArrowRight"/>
      </a>;
    }

    return <span ref={ ref }>{ value } </span>;
  };

  return (
    <div style={ style ?? style } className={ classnames({
      'horse-racing-betslip__footer__selections__info-item': true,
      [className]: className
    }) }>
      <div className={ classnames({
        'horse-racing-betslip__footer__selections__info-item__label': true,
        'horse-racing-betslip__footer__selections__info-item__label--coupon-amount': couponAmount
      }) }>
        <span>
          { label }
        </span>
        { onInfoClick && <Icon iconName="svgInfoGreyCircle" onClick={ onInfoClick }/> }
      </div>

      <div className="horse-racing-betslip__footer__selections__info-item__value">
        { renderValue() }
      </div>
    </div>
  );
};

HorseRacingBetSlipInfoItem.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onValueClick: PropTypes.func,
  inputMaxLength: PropTypes.number,
  className: PropTypes.string,
  couponAmount: PropTypes.bool,
  style: PropTypes.object,
  onInfoClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default React.forwardRef(HorseRacingBetSlipInfoItem);
